import "../../../../content/projects/tonika/tonika.css";
import * as React from 'react';
export default {
  React
};